import React from 'react';

import { rosterConfig } from '../roster-config';

const { FOOTER_BLOCK_HEIGHT } = rosterConfig;

interface FooterSpacerProps {
  width: number;
  height?: number;
}

export function FooterSpacer({ width, height = FOOTER_BLOCK_HEIGHT }: FooterSpacerProps) {
  return <div className='roster-gray bordered-top' style={{ width: `${width}px`, height }} />;
}
